import {
    CloseIcon,
    IconScroll,
    ModalContent,
    ModalContentBody,
    ModalContentFooter,
    ModalContentFooterCheck,
    ModalContentFooterSubmit,
    ModalContentHead,
    ModalContentHeadTitle,
    ScrollDown
} from "./style";
import {useApp} from "../../contexts/app";
import {useEffect, useRef, useState} from "react";

export default function Consent(props: any) {
    const {campaign, customer, T} = useApp();
    const [checked, setChecked] = useState(false);
    const [isFinish, setIsFinish] = useState(true);
    const contentRef = useRef<HTMLInputElement>(null);
    const contentBodyRef = useRef<HTMLInputElement>(null);
    const endContentRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (contentRef?.current?.clientHeight < contentBodyRef.current.scrollHeight && campaign?.isScrollToFinnish) {
            setIsFinish(false)
        } else {
            setIsFinish(true)
        }
    }, [campaign?.isScrollToFinnish])

    const handleScroll = (e) => {
        const isBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 5;
        if (isBottom) {
            setIsFinish(true)
        }
    }

    const scrollToBottom = (e) => {
        e.preventDefault();
        if (endContentRef?.current) {
            setTimeout(() => {
                endContentRef.current?.scrollIntoView({behavior: "smooth"})
            }, 100)
        }
    }
    return (
        <ModalContent style={{height: window.innerHeight - 40}}>
            <ModalContentHead>
                <CloseIcon onClick={() => props.onClose(false)}/>
                <ModalContentHeadTitle>{T('Consent form')}</ModalContentHeadTitle>
            </ModalContentHead>
            <ModalContentBody style={{flex: 1}} className={'no-scrollbar'} onScroll={handleScroll} ref={contentRef}>
                <div ref={contentBodyRef} className={'content wrap-html'}
                     dangerouslySetInnerHTML={{__html: (campaign?.customerConsentForm || "")}}></div>
                <div ref={endContentRef}/>
            </ModalContentBody>
            {isFinish ?
                <ModalContentFooter>
                    <ModalContentFooterCheck checked={checked}
                                             onChange={event => setChecked(event.target.checked)}>{T('I agree to the above')}</ModalContentFooterCheck>
                    <ModalContentFooterSubmit onClick={() => props.onClose(true)}
                                              disabled={!checked}>{T('Next')}</ModalContentFooterSubmit>
                </ModalContentFooter> :
                <ScrollDown onClick={scrollToBottom}>
                    <IconScroll/>{T('Scroll down to read more')}</ScrollDown>
            }

        </ModalContent>
    )
}